import EventBus from '@/helpers/event-bus';
import ApplicationsService from '@/services/Applications/ApplicationsService';

const state = {
  applications: [],
  groupedApplicationLinkValues: {},
  editData: {},
  years: [],
  current: {
    composition: null,
    applications: []
  }
};

const actions = {
  async getApplicationLinks({ commit }) {
    try {
      const { data } = await ApplicationsService.getApplicationLinks();

      const groupedApplicationLinkValues = {};
      data.forEach(link => {
        if (!Array.isArray(groupedApplicationLinkValues[link.composition_id])) {
          groupedApplicationLinkValues[link.composition_id] = [];
        }
        if (Array.isArray(link.applications)) {
          link.applications
            .forEach((application) => {
              groupedApplicationLinkValues[link.composition_id].push(application.volume);
            });
        }
      });

      commit('groupedApplicationLinkValues', groupedApplicationLinkValues);
      commit('applications', data);

      let applicationsYears = [];

      data.forEach(e => {
        applicationsYears.push(e.createdAt.substr(0, 4));
      });

      applicationsYears = applicationsYears.filter((e, i, a) => i === a.indexOf(e));
      if (applicationsYears.length === 0) {
        applicationsYears.push(new Date().getFullYear().toString());
      }

      commit('years', applicationsYears.sort().reverse());
    } catch (error) {
      console.error(error.message);
    }
  },
  years() {
    /*
    return SubmissionService.getSubmissions().then((result) => {
      let t = [];
      result.data.forEach(e => {
        t.push(e.substr(0, 4));
      });
      t = t.filter(e, i, a) => i === a.indexOf(e)
      commit('years', t.sort().reverse());
    });
    */
  },
  setPercentage({ commit }, value) {
    commit('setPercentage', value);
  },
  async save(_, compositionId) {

    try {
      const applications = state.current.applications.map(application => ({
        application_id: application.id,
        volume: application.volume
      }));
      if (applications.length) {
        const { data } = await ApplicationsService.saveApplicationLink({
          applications,
          composition_id: compositionId,
        });
        if (data && data.status === 1) {
          EventBus.$emit('snotifySuccess', 'Application saved.');
        }
      }
    } catch (error) {
      EventBus.$emit('snotifySuccess', error.message);
    }
  },
  async update(_, compositionId) {
    try {
      const { data } = await ApplicationsService.updateApplicationLink(
        compositionId,
        state.current.application_id,
        state.current.applications.map(application => ({
          application_id: application.id,
          volume: application.volume
        }))
      );
      if (data && data.status === 1) {
        EventBus.$emit('snotifySuccess', 'Application updated.');
      }
    } catch (error) {
      EventBus.$emit('snotifySuccess', error.message);
    }
  },
  async remove(_, compositionId) {
    try {
      const { data } = await ApplicationsService.removeApplicationLink(compositionId);
      if (data && data.status === 1) {
        EventBus.$emit('snotifySuccess', 'Application removed.');
      }
    } catch (error) {
      EventBus.$emit('snotifySuccess', error.message);
    }
  }
};

const mutations = {
  applications(state, data) {
    state.applications = data;
  },
  groupedApplicationLinkValues(state, data) {
    state.groupedApplicationLinkValues = data;
  },
  years(state, data) {
    state.years = data;
  },
  current(state, data) {
    state.current = data;
  },
  setEditData(state, data) {
    state.editData = data;
  },
  setPercentage(state, data) {
    if (typeof state.current === 'undefined') {
      state.current = {};
    }
    if (typeof state.current.applications === 'undefined') {
      state.current.applications = [];
    }
    const t = state.current.applications.filter(e => e.id === data.id);
    if (t.length) {
      t[0].volume = data.volume;
    }
    else {
      state.current.applications.push(data);
    }
  }
};

const getters = {
  applications(state) {
    return state.applications;
  },
  years(state) {
    return state.years;
  },
  current(state) {
    return state.current;
  }
};

export default {
  state,
  mutations,
  actions,
  getters,
  namespaced: true
};
